import React from "react";
import ImageView from "../../../components/SmartImage";
import { StickBottomContainer } from "./styles";
const StickBottomTab = (props) => {
    const { positionId, images, bgColor } = props;
    return (React.createElement("section", { id: positionId },
        React.createElement(StickBottomContainer, { bgColor: bgColor }, images.map((ele, index) => {
            return (React.createElement("a", { key: `${index}${ele.link}`, href: ele.link },
                React.createElement(ImageView, { src: ele.img, online: true })));
        }))));
};
export default StickBottomTab;
